var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueInfoIcon = function SvgBlueInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0057B8",
    fillRule: "evenodd",
    d: "M8.906 6.531h1.188V5.344H8.906zm0 7.125h1.188V7.72H8.906zM9.5.594C4.59.594.594 4.589.594 9.5c0 4.91 3.995 8.906 8.906 8.906 4.91 0 8.906-3.995 8.906-8.906 0-4.91-3.995-8.906-8.906-8.906",
    clipRule: "evenodd"
  })));
};
export default SvgBlueInfoIcon;